export default state => state.identities || [];
